module.exports = __webpack_public_path__ + "img/NeoBankIN.f580185e.png";